/* eslint-disable import/no-anonymous-default-export */
import Config from "../config/index";
import getToken from "./getToken";

import HTTP from "./httpInstance";

export default async (request) => {
  request.method = request.method || "get";
  request.url = `${Config.APP_API_URL}/${request.url}`;
  request.data = request.data || {};
  if (request.data && request.method === "get") {
    request.data = null;
  }

  const token = await getToken();
  if (token) {
    request.headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "http://localhost:3000",
      ...request.headers,
    };
  }

  return HTTP(request);
};
